<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        {{ id ? "UPDATE" : "CREATE" }} SATIFICATION SURVEY
      </h1>
    </div>

    <Form />
  </div>
</template>

<script>
import Form from "./components/Form.vue";
export default {
  name: "CastFormSettingDetail",
  components: { Form },
  data() {
    return {
      id: this.$route.params.id,
    };
  },
};
</script>

<style lang="scss" scoped></style>
